import { render, staticRenderFns } from "./ticketCerrado.vue?vue&type=template&id=dc864ffa"
import script from "./ticketCerrado.vue?vue&type=script&lang=js"
export * from "./ticketCerrado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports